import { setTenantName } from "../../features/token/TokenEncryption"
import {
  ITenantType,
  IUserInformation,
  IUserPermission
} from "../../features/user/state/UserTypes"

const USER_PERMISSION = "userPermission"
const USER_INFORMATION = "userInfo"
const USER_LOCALIZATION = "userLocalization"
const TENENT_TYPE = "tenantType"

export const setUserPermission = (data: any): void => {
  sessionStorage.setItem(USER_PERMISSION, JSON.stringify(data))
}

export const setTenentType = (data: any): void =>
  sessionStorage.setItem(TENENT_TYPE, JSON.stringify(data))

export const setUserInformation = (data: IUserInformation): void => {
  sessionStorage.setItem(USER_INFORMATION, JSON.stringify(data))
  setTenantName(data.currentTenantName);
}

// Set localization data (key-value pair object) in sessionStorage
export const setUserLocalization = (localization: Record<string, string>): void => {
  sessionStorage.setItem(USER_LOCALIZATION, JSON.stringify(localization));
}

// Add a key-value pair to the existing localization object
export const addLocalizationKeyValue = (key: string, value: string): void => {
  const currentLocalization = getUserLocalization() || {}; // Get existing data or initialize as empty object
  currentLocalization[key] = value; // Add new key-value pair
  setUserLocalization(currentLocalization); // Save updated localization back to sessionStorage
}

export const getUserPermission = (): IUserPermission => JSON.parse(sessionStorage.getItem(USER_PERMISSION) as string)

export const getTenantType = (): ITenantType => JSON.parse(sessionStorage.getItem(TENENT_TYPE) as string)

export const getUserRole = (): string => getUserPermission()?.currentRole
export const canCurrentUserWrite = (): boolean => getUserPermission()?.currentPermission === "w" ? true : false

export const getCurrentUserEmail = (): string =>
  sessionStorage.getItem("email") as string

export const getCurrentUserId = (): string => getUserPermission()?.userId

export const getCurrentUserOrgId = (): string => getUserPermission().currentOrg

export const getCurrentUserTenantId = (): string => getUserPermission().currentTenant

export const getUserInfo = (): IUserInformation =>
  JSON.parse(sessionStorage.getItem(USER_INFORMATION) as string)

export const getUserFullName = (): string => `${getUserInfo().firstName} ${getUserInfo().lastName}`

export const getUserTimeZone = (): string => getUserInfo().timezone

export const getCurrentOrgName = (): string => getUserInfo()?.currentOrgName

export const getNewAppointmentCount = (): number => getUserInfo()?.newAppointmentCount

// Get localization data from sessionStorage
export const getUserLocalization = (): Record<string, string> | null => {
  const localizationData = sessionStorage.getItem(USER_LOCALIZATION);
  return localizationData ? JSON.parse(localizationData) : null;
}

// Get a specific localization key's value
export const getLocalizationValue = (key: string): string | null => {
  const localizationData = getUserLocalization();
  if(localizationData)
  {
    const value = localizationData[key];
    if(value != null)
    {
      return value;
    }
  }
  return key;
}

export interface IUserSessionToken {
  userSession: {
    id: string;
    apiToken: string;
  };
}
